import React, { useState } from 'react';
import { CheckCircle, Target, Eye, Heart } from 'lucide-react';
import './styles/missionvalue.css';
import one from './assets/bg1.jpg'; 
import two from './assets/bg2.jpg'; 
import three from './assets/bg3.jpg'; 


const MissionValueSection = () => {
  const [activeTab, setActiveTab] = useState('mission');

  const tabs = [
    {
      id: 'mission',
      title: 'Our Mission',
      icon: <Target />,
      image: one,
      content:
        'To provide high-quality, reliable medical equipment to healthcare providers in Nepal, ensuring improved patient care and better health outcomes.',
      items: [
        'Sourcing and supplying cutting-edge medical technology',
        'Ensuring timely delivery and installation of equipment',
        'Offering comprehensive after-sales support and maintenance',
        'Partnering with leading medical equipment manufacturers',
      ],
    },
    {
      id: 'vision',
      title: 'Our Vision',
      icon: <Eye />,
      image: two,
      content:
        'To be the leading medical equipment supplier in Nepal, empowering healthcare professionals with innovative solutions to revolutionize patient care.',
      items: [
        'Expanding our reach to serve all regions of Nepal',
        'Becoming a trusted partner for healthcare institutions',
        'Contributing to the advancement of medical technology in Nepal',
        'Promoting continuous improvement in healthcare delivery',
      ],
    },
    {
      id: 'value',
      title: 'Our Values',
      icon: <Heart />,
      image: three,
      content:
        'We are committed to integrity, quality, and patient well-being. We strive for excellence in everything we do, fostering a culture of innovation and collaboration.',
      items: [
        'Providing ethical and transparent business practices',
        'Delivering products that meet the highest quality standards',
        'Prioritizing patient safety and well-being in all our endeavors',
        'Building strong relationships with our clients and partners',
      ],
    },
  ];

  const activeContent = tabs.find((tab) => tab.id === activeTab);

  return (
    <div className="mvs-container">
      <div className="mvs-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`mvs-tab ${activeTab === tab.id ? 'active' : ''}`}
          >
            <div className="mvs-tab-icon">{tab.icon}</div>
            <span className="mvs-tab-title">{tab.title}</span>
          </button>
        ))}
      </div>

      <div className="mvs-content">
        <div className="mvs-text-section">
          <p className="mvs-description">{activeContent?.content}</p>
          <div className="mvs-items">
            {activeContent?.items.map((item, index) => (
              <div key={index} className="mvs-item">
                <CheckCircle className="mvs-item-icon" />
                <span className="mvs-item-text">{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mvs-image-section">
          <img
            src={activeContent?.image}
            alt={`${activeContent?.title} illustration`}
            className="mvs-image"
          />
        </div>
      </div>
    </div>
  );
};

export default MissionValueSection;